import React, { useState, useCallback } from 'react';

import PropTypes from 'prop-types';

import { Menu, MenuItem, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import languages from 'src/consts/languages';

const useStyles = makeStyles()(theme => ({
  lng: {
    ...theme.typography.button,
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '12px 10px',
    borderLeft: '1px solid rgb(221, 221, 221)',
    transition: 'all 200ms ease-in-out 0s',
    display: 'inline-block',
    opacity: 0.8,
    '&:hover': { opacity: 1 },
  },
}));

function LangButton({ currentLang, selectLang, title }) {
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClose() {
    setAnchorEl(null);
  }

  const handleClick = useCallback(e => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  }, []);

  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={title}>
        <div onClick={handleClick} className={classes.lng}>
          {currentLang.shortName}
        </div>
      </Tooltip>
      <Menu
        MenuListProps={{ disablePadding: true }}
        value
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={e => {
          e.preventDefault();
          handleClose();
        }}
        PaperProps={{
          style: {
            minWidth: 150,
          },
        }}
      >
        {languages.map(language => (
          <MenuItem
            dense
            selected={language.locale === currentLang.locale}
            disabled={language.locale === currentLang.locale}
            key={language.locale}
            onClick={() => {
              handleClose();
              selectLang(language);
            }}
          >
            {t(`smartmessaging.language.${language.shortName}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

LangButton.propTypes = {
  selectLang: PropTypes.func.isRequired,
  currentLang: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default LangButton;
